import React from "react";
import ReactDOM from "react-dom";

//style
import "./Style/index.css";

//components
import App from "./Components/App";

ReactDOM.render(<App />, document.getElementById("root"));
